import React from "react";

export const CancelButton = ({ onClick, buttonText = "Cancel" }) => {
  return (
    <button
      id="cancel-btn"
      type="button"
      className="close axa-header-close col-sm-1 col-md-1 col-3 align-self-center"
      aria-label="Cancel"
      onClick={(event) => {
        event.preventDefault();
        onClick();
      }}
    >
      <span aria-hidden="true">
        <span className="close-text">{buttonText}</span> ×
      </span>
    </button>
  );
};
